import styled from 'styled-components'

export const Title = styled.h1`
    margin-left: 10%;
    margin-top: 5%;
    margin-bottom: 5%;

    text-align: center;
    
    color: white;
    border: 10px solid #F26E0E;
    width: max-content;
    height: max-content;
    border-radius: 30px;
    background-color: #F26E0E;

    @media only screen and (max-device-width: 800px) {
        margin-top: 15%;
        font-size: 20px;
    }
`
export const Description = styled.p`
    font-size: 22px;
    color: white;
    margin-left: 250px;
    margin-right: 1%;
    align-items: center;

    @media only screen and (max-device-width: 800px) {
        margin-top: 15%;
        margin-left: 30px;
        font-size: 18px;
        justify-content: center;
        align-items: center;
    }
`

export const Links = styled.a`
    font-size: 16px;
    text-decoration: none;
    color: white;
    margin-left: 15%;
    border: 10px solid #F26E0E;
    width: max-content;
    height: max-content;
    border-radius: 30px;
    background-color: #F26E0E;
    display: inline-flex;


    a{
        text-decoration: none;
        color: white;
    }
    &:hover, &:focus{
        opacity: .8;
    }

    @media only screen and (max-device-width: 800px) {
        margin-top: 1%;
        margin-left: 0;
        font-size: 12px;
        

    }
`
